module.exports = __webpack_public_path__ + "static/img/ramen.0ede317.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ramen.gif
// module id = kuFF
// module chunks = 4